// Central content pulled & adapted from rangerconstruction.com
export const BRAND = {
  name: "Ranger Construction",
  // Current approved Ranger brand mark.
  logo: "/assets/ranger-logo-clean.png",
  logoLight: "/assets/ranger-logo-clean.png",
  tagline: "A Leading Florida Road Building & Asphalt Producing Contractor",
};

export const IMG = {
  heroNight:
    "/assets/mirrored/Home_page_banner_5-scaled-7e4330b4.jpg",
  ellison:
    "/assets/ellison-wilson-road.jpg",
  centralFlorida:
    "/assets/central-florida-resurfacing-20261009.jpg",
  s1: "/assets/ranger-highway.jpg",
  s2: "/assets/precision-asphalt-paving.jpg",
  s3: "/assets/subbase-reclamation-20261026.jpg",
  s4: "/assets/mirrored/Services-Pics_4-800x446-1-1fdf8309.jpg",
  s6: "/assets/mirrored/Services-Pics_6-800x533-1-fc677d6d.jpg",
  turnkeySiteDevelopment: "/assets/earthmoving-grading.jpg",
  undergroundUtilitiesStormwater: "/assets/underground-utilities-20261026.jpg",
  commercialHoaPaving: "/assets/commercial-hoa-paving.jpg",
  industrialSpecialty: "/assets/industrial-specialty.jpg",
  siteWorkCommercialHero: "/assets/site-work-commercial-hero.jpg",
  airport:
    "/assets/mirrored/RCI-VeroAirport-1-adafe19c.jpg",
  safety:
    "/assets/mirrored/Safety_img1-e2fdff0b.jpg",
  safetyTeam:
    "/assets/mirrored/yscz0k6a_Saftey-one-e62c44e4.png",
  careers1:
    "/assets/careers-field-team-20261009.jpg",
  careers2:
    "/assets/careers-night-paving.jpg",
  asphaltMap:
    "/assets/mirrored/Asphalt_Sales_map-b92bdd20.jpg",
  servicesBanner:
    "/assets/mirrored/6th-Ave-for-Web-new-scaled-890120b6.jpg",
  safetyBriefing: "/assets/safety-briefing-20261026.jpg",
  safetyBanner:
    "/assets/mirrored/Safety_banner_5-scaled-7bbadec8.jpg",
  materialsPlantSales: "/assets/materials-plant-sales-aerial.jpg",
  asphaltBanner:
    "/assets/mirrored/Ranger_truck_at_silos-scaled-10a6ea4d.jpg",
  careersBanner:
    "/assets/mirrored/Careers_banner_4-1-scaled-617e1624.jpg",
  vanguardBanner:
    "/assets/mirrored/VanGuard-Banner-7dc24989.jpg",
  contactBanner:
    "/assets/mirrored/Building-Contact-Us-scaled-745d4ffc.jpg",
};

export const NAV = [
  { key: "home", label: "Home", path: "/" },
  { key: "about", label: "About", path: "/about/company-history" },
  { key: "services", label: "Services", path: "/services" },
  { key: "asphalt-plants", label: "FOB Asphalt Sales", path: "/asphalt-plants" },
  { key: "safety", label: "Safety", path: "/safety" },
  { key: "projects", label: "Projects", path: "/projects" },
  { key: "news", label: "News", path: "/news" },
  { key: "careers", label: "Careers", path: "/careers" },
  { key: "contact", label: "Contact", path: "/contact" },
  { key: "vanguard", label: "The VanGuard News Magazine", path: "/news/vanguard-magazine" },
];

export const STATS = [
  { value: "4", label: "Asphalt Plants" },
  { value: "4", label: "Regional Offices" },
  { value: "FDOT", label: "Trusted Partner" },
  { value: "NAPA", label: "Environmental Award" },
];

export const SERVICES = [
  {
    slug: "heavy-highway-construction",
    key: "highway",
    title: "Heavy Highway Construction & Interstate Roadbuilding",
    short: "Turnkey delivery of high-volume transportation corridors, turnpikes, and complex highway interchanges.",
    img: IMG.s1,
    desc: "From interstates to city streets, our crews deliver heavy highway projects for FDOT, counties and municipalities — using both traditional methods and full-depth reclamation.",
    bullets: ["Multi-lane highway widening and corridor expansion", "Interchange design-build, bridge approaches, and toll plaza infrastructure", "Complex Maintenance of Traffic (MOT) and night paving operations", "Full compliance with Florida Department of Transportation (FDOT) standards"],
    ctaLabel: "Request an Infrastructure Bid", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "asphalt-paving-resurfacing",
    key: "paving",
    title: "Precision Asphalt Paving, Resurfacing & High-Output Milling",
    short: "High-tonnage placement, specialized milling fleets, and long-life asphalt rehabilitation.",
    img: IMG.s2,
    desc: "Precision paving, resurfacing and repaving backed by our own asphalt production — for highways, commercial lots, airports and private roads.",
    bullets: ["Interstate and primary arterial resurfacing", "Deep and surface milling with automated grade controls", "High-traffic commercial, municipal, and industrial pavement overlay", "In-house FDOT-approved mix designs"],
    ctaLabel: "Order FOB Mixes / Get Paving Estimate", ctaTo: "/asphalt-plants/fob-mix-designs",
  },
  {
    slug: "full-depth-reclamation",
    key: "reclamation",
    title: "Sustainable Subbase Stabilization & Full-Depth Reclamation",
    short: "Cost-effective, in-place pavement recycling engineered to maximize roadway longevity.",
    img: IMG.s3,
    desc: "We rebuild failing roads in place — pulverizing and stabilizing existing materials to create a strong new base, reducing cost and waste.",
    bullets: ["In-place pulverization and recycling of deteriorated asphalt pavements", "Chemical subbase stabilization using cement, lime, and emulsion additives", "Reduced trucking cycles, carbon footprint, and overall project costs", "Rapid base stabilization for accelerated paving schedules"],
    ctaLabel: "Consult with a Base Specialist", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "site-preparation",
    key: "siteprep",
    title: "Site Preparation",
    short: "Clearing, grading and earthwork that sets the foundation for every project.",
    img: IMG.s6,
    desc: "Clearing, grading, earthwork and underground utilities — the groundwork that sets every roadway and development up for success.",
    bullets: ["Clearing & grubbing", "Grading & earthwork", "Drainage & utilities", "Subgrade preparation"],
  },
  {
    slug: "complete-site-development",
    key: "site-development",
    title: "Turnkey Site Development",
    short: "Turnkey packages from land clearing and mass earthwork to utility infrastructure and final paving.",
    img: IMG.turnkeySiteDevelopment,
    desc: "Complete civil packages from clearing and grading to underground utilities, access roads, and final paving.",
    bullets: ["Site clearing, grubbing, and mass grading", "Underground utility and storm-drainage installation", "Heavy-duty parking facilities and access roads", "Single-source civil accountability"],
    ctaLabel: "Submit Site Plans for Estimating", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "underground-utilities-stormwater",
    key: "utilities",
    title: "Underground Utilities & Stormwater Management",
    short: "High-capacity drainage, retention systems, water mains, and sanitary sewer construction.",
    img: IMG.undergroundUtilitiesStormwater,
    desc: "Stormwater, water, sewer, and deep-excavation utility scopes for complex civil sites.",
    bullets: ["Drainage pipe, box culverts, and retention ponds", "Potable water main installation and testing", "Sanitary sewer, pump stations, and force mains", "Dewatering and trench stabilization"],
    ctaLabel: "Discuss Utility Scopes", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "commercial-hoa-paving",
    key: "commercial",
    title: "Commercial & HOA Paving",
    short: "Paving, milling, and resurfacing for private developments, HOAs, and retail centers.",
    img: IMG.commercialHoaPaving,
    desc: "Dedicated paving and resurfacing solutions for private developments and commercial properties.",
    bullets: ["Community roadway paving", "Retail and logistics parking facilities", "Pavement maintenance plans", "ADA transitions and striping coordination"],
    ctaLabel: "Schedule Site Evaluation", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "specialty-services",
    key: "specialty",
    title: "Specialized Aviation, Port, Mechanical & Emergency Infrastructure",
    short: "High-load airfield paving, heavy industrial mechanical piping, and emergency recovery operations.",
    img: IMG.industrialSpecialty,
    desc: "FAA paving, industrial mechanical services, and rapid emergency recovery operations across Florida.",
    bullets: ["Aviation and intermodal paving to FAA P-401/P-403 specifications", "Heavy industrial piping, bulk fuel terminal manifolds, pipe racks, and valve stations", "Container terminal slabs and heavy-wheel-load port corridors", "Rapid hurricane recovery, post-storm road clearing, and wash-out repairs"],
    ctaLabel: "Contact Specialty Divisions", ctaTo: "/contact/request-a-bid",
  },
  {
    slug: "fob-asphalt-sales",
    key: "fob",
    title: "FOB Asphalt Sales",
    short: "High-quality FOB asphalt from four strategically located Florida supply locations.",
    img: IMG.s4,
    desc: "Pick up the same high-quality hot-mix asphalt we use on our own jobs from four strategically located supply points across Florida.",
    bullets: ["Four Florida supply locations", "Same mix we use", "Pricing by plant", "Reliable pickup"],
    cta: "/asphalt-plants",
  },
];

export const MARKETS = [
  "State Highways & City Streets",
  "Commercial & Retail",
  "Airport Runways",
  "HOA & Private Roadways",
];

export const PROJECTS = [
  {
    title: "Ellison Wilson Road",
    location: "Palm Beach County",
    type: "Roadway Reconstruction",
    category: "Airports & Municipal",
    img: IMG.ellison,
  },
  {
    title: "I-595 / Turnpike Night Paving",
    location: "Ft. Lauderdale",
    type: "Highway Resurfacing",
    category: "Highway & FDOT",
    img: IMG.heroNight,
  },
  {
    title: "Vero Beach Regional Airport",
    location: "Treasure Coast",
    type: "Runway Paving",
    category: "Airports & Municipal",
    img: IMG.airport,
  },
  {
    title: "Central Florida Resurfacing",
    location: "Greater Orlando",
    type: "Asphalt Paving",
    category: "Highway & FDOT",
    img: IMG.centralFlorida,
  },
  // Project names and recognition are documented in ContentPage's existing awards records.
  // Photos verified against VanGuard Q1/Q2 2026 p20 and ACAF 2024 awards pp34/39.
  {
    title: "Melbourne Orlando International Airport Taxiway A",
    img: "/assets/melbourne-taxiway-a.jpg",
    location: "Brevard County",
    type: "2026 ACAF Special Project of the Year",
    category: "Airports & Municipal",
  },
  {
    title: "Key West International Airport Runway 9-27",
    img: "/assets/key-west-runway-9-27.jpg",
    location: "Key West",
    type: "2024 ACAF Special Project recognition",
    category: "Airports & Municipal",
  },
  {
    title: "Cabana Colony Subdivision Residential Streets",
    img: "/assets/cabana-colony.jpg",
    location: "Palm Beach County",
    type: "2024 ACAF District 4 Roads & Streets recognition",
    category: "Residential & HOA",
  },
];

// The four top-level service areas shown in the primary navigation.  The
// homepage intentionally uses these hubs rather than the individual service
// offerings, so visitors land in the appropriate category first.
export const SERVICE_CATEGORIES = [
  {
    key: "heavy-highway-infrastructure",
    title: "Heavy Highway & Infrastructure",
    desc: "Roadbuilding, interstate construction, high-output paving and milling, plus full-depth reclamation and soil stabilization.",
    img: IMG.s1,
    cta: "/services/heavy-highway-infrastructure",
  },
  {
    key: "site-work-commercial",
    title: "Site Work & Commercial",
    desc: "Turnkey site development, utilities and stormwater management, mass grading, earthmoving, and commercial or HOA paving.",
    img: IMG.siteWorkCommercialHero,
    cta: "/services/site-work-commercial",
  },
  {
    key: "industrial-specialty",
    title: "Industrial & Specialty",
    desc: "Aviation, port, industrial mechanical, and emergency infrastructure services for Florida's most demanding projects.",
    img: IMG.industrialSpecialty,
    cta: "/services/industrial-specialty",
  },
  {
    key: "materials-plant-sales",
    title: "Materials & Plant Sales",
    desc: "FDOT-approved asphalt mixes, plant locations, pickup details, and dispatch support across Florida.",
    img: IMG.materialsPlantSales,
    cta: "/services/materials-plant-sales",
  },
];

export const PROJECT_CATEGORIES = {
  "highway-fdot": {
    label: "Highway & FDOT",
    description: "Interstate widening, multi-lane turnpikes, design-build expressway interchanges, and county thoroughfares.",
  },
  "commercial-industrial": {
    label: "Commercial & Site Work",
    description: "Mega distribution hubs, business parks, manufacturing pads, mass earthwork, and complete utility packages.",
  },
  "airports-municipal": {
    label: "Airports & Municipal",
    description: "FAA-certified airport runway overlays, taxiway reconstruction, municipal streetscapes, and port terminals.",
  },
  "residential-hoa": {
    label: "Residential & HOA",
    description: "Master-planned community access roads, subdivision civil packages, and neighborhood resurfacing programs.",
  },
};

export const NEWS_ITEMS = [
  {
    title: "Project ribbon cuttings and FDOT corridor completions",
    summary: "Milestones from Ranger roadway, site-development, and infrastructure teams across Florida.",
    category: "Projects",
  },
  {
    title: "Safety excellence awards and industry accolades",
    summary: "Recognition for the teams and programs advancing Ranger's zero-incident safety culture.",
    category: "Safety",
  },
  {
    title: "Community outreach and charity event spotlights",
    summary: "Updates from Ranger partnerships, workforce development, and regional outreach initiatives.",
    category: "Community",
  },
];

export const PLANTS = [
  { city: "Winter Garden / Orlando", address: "Serving Orange, Lake, Seminole, Osceola, Marion, Brevard, Sumter, and Polk Counties", phone: "407.749.6262" },
  { city: "Fort Pierce / Treasure Coast", address: "Serving St. Lucie, Martin, Indian River, Osceola, Brevard, and Okeechobee Counties", phone: "772.252.5990" },
  { city: "West Palm Beach", address: "Serving Palm Beach and Broward Counties", phone: "561.784.3485" },
  { city: "Miami / South Florida", address: "Serving Miami-Dade and Florida Keys corridors", phone: "305.828.9464" },
];

export const OFFICES = [
  {
    name: "Headquarters",
    address: "1645 N. Congress Ave., West Palm Beach, FL 33409",
    phone: "561.793.9400",
    email: "info@rangerconstruction.com",
    hq: true,
  },
  {
    name: "Winter Garden Office",
    address: "1200 Elboc Way, Winter Garden, FL 34787",
    phone: "407.656.9255 / 800.769.8383",
  },
  {
    name: "Ft. Pierce Office",
    address: "4510 Glades Cutoff Rd., Ft. Pierce, FL 34979",
    phone: "772.464.6460",
  },
  {
    name: "Miami Office",
    address: "17800 NW 122nd Ave., Hialeah, FL 33018",
    phone: "305.718.8070",
  },
];

export const SAFETY_FOCUS = [
  "Personal Protective Equipment",
  "Traffic Control",
  "Job Hazard Analysis",
  "Heat Illness Prevention",
  "Defensive Driving",
  "Fall Prevention",
  "Crane Safety",
  "Drug-Free Workplace",
];

export const SAFETY_FOCUS_FULL = [
  "Personal Protective Equipment (PPE)",
  "Hazardous Materials",
  "Electrical Hazards",
  "Lockout-Tagout",
  "Driving & Operating Equipment",
  "Excavations",
  "Working Safely Around Utilities",
  "Crane Safety",
  "Proper Lifting",
  "Job Hazard Analysis",
  "Traffic Control",
  "Reporting Accidents & Unsafe Conditions",
  "Heat Illness Prevention",
  "Drug-Free Workplace",
  "Defensive Driving",
  "Fall Prevention",
];

export const SAFETY_IRR = [
  "A detailed account of the incident",
  "Witness statements",
  "Photographic documentation",
  "Root cause analysis",
  "Corrective action plans",
  "Key lessons learned",
];

export const SAFETY_DISCIPLINE = [
  "Documented verbal or written warnings",
  "Suspension",
  "Termination for serious or repeated violations",
];

export const CAREER_ROLES = [
  "Equipment Operators",
  "Truck Drivers (CDL & Non-CDL)",
  "Asphalt Plant Operators",
  "Paving & Milling Crews",
  "Project Managers & Engineers",
  "Estimators",
  "Safety Coordinators",
  "Mechanics & Fleet Maintenance",
];

export const SERVICE_AREA =
  "From the greater Orlando area north near Ocala and south through the Treasure Coast, Palm Beaches, Ft. Lauderdale, Miami, and the Florida Keys.";

export const CAREER_OPENINGS = [
  { location: "Winter Garden, FL", roles: ["Asphalt Superintendent", "Asphalt Rakers", "Tack Truck Driver", "Heavy Equipment Mechanics"] },
  { location: "Ft. Pierce, FL", roles: ["Dump Truck Drivers", "Skid Steer Operators", "Loader Operators", "Heavy Equipment Mechanics"] },
  { location: "West Palm Beach, FL", roles: ["Asphalt Plant Operators", "Project Managers", "Project Engineers", "Estimators", "Superintendents"] },
];

export const VANGUARD = {
  title: "The Vanguard News Magazine",
  intro:
    "The Vanguard is Ranger Construction's company news magazine — celebrating our people, projects, safety milestones and the communities we build across Florida.",
  highlights: [
    "Project spotlights from across Central & South Florida",
    "Safety recognition and team achievements",
    "Company news, milestones and events",
    "Career journeys and employee stories",
  ],
  issues: [
    {
      id: "q1-q2-2025",
      title: "Q1 / Q2 2025",
      period: "Issue No. 1",
      pdf: "/vanguard/the-vanguard-q1-q2-2025.pdf",
    },
  ],
};
